import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { EventProvider } from "@/context/EventContext";
import { Toaster } from "@/components/ui/sonner";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Memories from "@/pages/Memories";
import CreateEvent from "@/pages/CreateEvent";
import Dashboard from "@/pages/Dashboard";
import Guests from "@/pages/Guests";
import Invitation from "@/pages/Invitation";
import Tasks from "@/pages/Tasks";
import Budget from "@/pages/Budget";
import Vendors from "@/pages/Vendors";
import Seating from "@/pages/Seating";
import Gallery from "@/pages/Gallery";
import ThankYou from "@/pages/ThankYou";
import Setup from "@/pages/Setup";
import Pricing from "@/pages/Pricing";
import Messages from "@/pages/Messages";
import PrintSeating from "@/pages/PrintSeating";
import PrintGuests from "@/pages/PrintGuests";
import PublicRSVP from "@/pages/PublicRSVP";
import PublicWedding from "@/pages/PublicWedding";
import PublicNameRSVP from "@/pages/PublicNameRSVP";
import CohostAccept from "@/pages/CohostAccept";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import VerifyEmail, { VerifyPending } from "@/pages/VerifyEmail";
import Account from "@/pages/Account";
import ResetPassword from "@/pages/ResetPassword";
import Contacts from "@/pages/Contacts";
import AuthCallback from "@/pages/AuthCallback";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null) return <div className="min-h-screen grid place-items-center text-stone-300 font-serif text-2xl" style={{ background: "#FDFBF7" }}>Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (user.email_verified === false) return <VerifyPending />;
  return children;
}

function Ev({ children }) {
  return <Protected><EventProvider>{children}</EventProvider></Protected>;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-center" />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/auth/callback" element={<AuthCallback />} />
          <Route path="/app" element={<Protected><Memories /></Protected>} />
          <Route path="/account" element={<Protected><Account /></Protected>} />
          <Route path="/contacts" element={<Protected><Contacts /></Protected>} />
          <Route path="/verify-email" element={<VerifyEmail />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/create" element={<Protected><CreateEvent /></Protected>} />

          <Route path="/e/:eventId/dashboard" element={<Ev><Dashboard /></Ev>} />
          <Route path="/e/:eventId/guests" element={<Ev><Guests /></Ev>} />
          <Route path="/e/:eventId/invitation" element={<Ev><Invitation /></Ev>} />
          <Route path="/e/:eventId/tasks" element={<Ev><Tasks /></Ev>} />
          <Route path="/e/:eventId/budget" element={<Ev><Budget /></Ev>} />
          <Route path="/e/:eventId/vendors" element={<Ev><Vendors /></Ev>} />
          <Route path="/e/:eventId/seating" element={<Ev><Seating /></Ev>} />
          <Route path="/e/:eventId/gallery" element={<Ev><Gallery /></Ev>} />
          <Route path="/e/:eventId/thankyou" element={<Ev><ThankYou /></Ev>} />
          <Route path="/e/:eventId/setup" element={<Ev><Setup /></Ev>} />
          <Route path="/e/:eventId/pricing" element={<Ev><Pricing /></Ev>} />
          <Route path="/e/:eventId/messages" element={<Ev><Messages /></Ev>} />
          <Route path="/e/:eventId/print/seating" element={<Ev><PrintSeating /></Ev>} />
          <Route path="/e/:eventId/print/guests" element={<Ev><PrintGuests /></Ev>} />

          <Route path="/rsvp/:token" element={<PublicRSVP />} />
          <Route path="/w/:slug" element={<PublicWedding />} />
          <Route path="/r/:slug" element={<PublicNameRSVP />} />
          <Route path="/cohost/:token" element={<CohostAccept />} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/payment/cancel" element={<PaymentCancel />} />

          <Route path="/dashboard" element={<Navigate to="/app" replace />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
